var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#5A73A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15.5C24.5 17.9853 22.4853 20 20 20C17.5147 20 15.5 17.9853 15.5 15.5C15.5 13.0147 17.5147 11 20 11C22.4853 11 24.5 13.0147 24.5 15.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.1667C12 25.7711 12 25.0733 12.1722 24.5055C12.56 23.2271 13.5605 22.2267 14.8389 21.8389C15.4067 21.6667 16.1044 21.6667 17.5 21.6667H22.5C23.8956 21.6667 24.5933 21.6667 25.1611 21.8389C26.4395 22.2267 27.44 23.2271 27.8278 24.5055C28 25.0733 28 25.7711 28 27.1667C28 27.6319 28 27.8645 27.9426 28.0537C27.8133 28.4798 27.4798 28.8133 27.0537 28.9426C26.8644 29 26.6319 29 26.1667 29H13.8333C13.3681 29 13.1356 29 12.9463 28.9426C12.5202 28.8133 12.1867 28.4798 12.0574 28.0537C12 27.8645 12 27.6319 12 27.1667Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/coach.52ce774f5935f3998d99b55f80d3dcdc.svg";
export { ForwardRef as ReactComponent };